import CustomerInformation from './customer-information';

export default CustomerInformation;
export { CustomerInformation };